export enum ViewListAsSelection {
    Unselected = '-1',
    Summary = 'b',
    ChartListView = 'e',
    ChartBook = 'g',
    GalleryView = 'l',
    CandleGlance = 'f',
    SymbolSummary = '0',
    Performance = '4',
    Options = '7',
    Seasonality = 's',
    RRG = 'u',
    MarketCarpet = 'h',
    Correlation = 'p',
    Edit = 'c'
}